import Vue from 'vue'

Vue.filter('capitalize', function (value) {
  if (value) {
    return value.toLowerCase().replace(/\_/g, " ").replace(/^\w|\s\w/g, function (letter) {
        return letter.toUpperCase()
    })
  }
})
